<template>
  <v-container>
    <div>
      <presentation-chat-r-d-g v-if="questions.length === 0" />
      <!-- V FOR ICI -->
      <div v-else v-for="(item, index) in questions" :key="index" class="card-chat">
        <div>
          <container-msg-r-d-g :message="item" :color="'#f2f4f7'" :color-border="'#12b09d'" :user="''" />
        </div>
        <div v-if="responses[index] !== undefined && responses[index] != null">
          <container-msg-r-d-g :message="responses[index]" :color="'#f5f5fe'" :color-border="'#000091'" />
        </div>
        <div v-if="value !== '' && nb === index">
          <container-msg-r-d-g :message="value" :color="'#f5f5fe'" :color-border="'#000091'" />
        </div>
        <div v-if="value === '' && responses[index] === undefined">
          <v-progress-linear indeterminate color="#12b09d"></v-progress-linear>
        </div>

        <!-- Sources -->
        <ResponseInfos :infos="sources[index]" class="mb-4" />

        <!-- Évaluation de la réponse du modèle -->
        <div v-if="value === '' && responses[index] !== undefined && responses[index] !== null">
          <div v-if="!hasRated[index]" class="bg-grey-lighten-5 pt-3 pl-2 ia-eval">
            <span class = "opacity-50">
              <v-icon>{{ mdiCheckCircle }}</v-icon> Evaluation de l'IA
            </span>
            <v-item-group v-model="note[index]" class="row px-sm-6 px-2 pt-2 pb-6 d-inline-flex ml-2 ia-eval-group">
              <v-item v-for="n in 6" :key="n - 1">
                <template v-slot:default="{ toggle }">
                  <v-btn :active="note[index] != null && note[index] + 1 >= n" border height="40" class="ms-1"
                    variant="text" width="20" :title="legends[n - 1]" @click="toggle">
                    {{ n - 1 }}
                  </v-btn>
                </template>
              </v-item>
              <v-btn width="100" class="ms-1" @click.stop="submitNote(index)"
                title="L'évaluation nous aide à améliorer le service">
                Envoyer</v-btn>
            </v-item-group>
            <div v-if="noNoteError[index]" class="text-caption text-error pl-2 pb-2" style="color: red;">
              ⚠️ Veuillez sélectionner une note avant d'envoyer.
            </div>
          </div>
          <div v-else class="bg-grey-lighten-5 pt-3 pl-2 pb-3 mb-2 ia-eval" style="color: #12b09d;">
            <v-icon>{{ mdiCheckCircle }}</v-icon> Merci, votre évaluation a bien été prise en compte.
          </div>
        </div>

        <!-- Disclaimer after each response -->
        <div v-if="responses[index] !== undefined && responses[index] !== null" class="mt-4">
          <v-alert type="info" variant="tonal" density="compact" class="text-caption">
            <strong>Note :</strong> En raison de la nature probabiliste des modèles d'IA, des erreurs (hallucinations) peuvent survenir. 
            Veuillez vérifier les informations fournies. ChatSO ne remplace pas l'expertise des personnels des ateliers de la donnée. 
            En cas de doutes, contactez les services compétents : 
            <a href="mailto:ateliers-donnee-gt1@groupes.renater.fr">ateliers-donnee-gt1@groupes.renater.fr</a>
          </v-alert>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script setup>
import { defineProps, ref, watch } from "vue";
import ContainerMsgRDG from "@/components/ContainerMsgRDG.vue";
import config from "@/config/config.js";
import PresentationChatRDG from "@/components/PresentationChatRDG.vue";
import ResponseInfos from "@/components/ResponseInfos.vue";
import { mdiCheckCircle } from "@mdi/js";

const props = defineProps({
  questions: Array,
  value: String,
  nb: Number,
  responses: Array,
  sources: Array,
});

const urlServeur = config.apiUrl + "/save-content"
const legends = [
  'Hors sujet',
  'Réponse insatisfaisante',
  'Réponse incomplète',
  'Réponse satisfaisante',
  'Bonne réponse',
  'Réponse parfaite'
]

const note = ref([]) // Tableau pour stocker les notes
const hasRated = ref([]) // Tableau pour indiquer si une note a déjà été donnée
const noNoteError = ref([]) // Tableau pour afficher une erreur si aucune note sélectionnée

function sendContent(question, response, note) {
  const dataToSend = { question, response, note }
  fetch(urlServeur, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataToSend),
  });
}

function submitNote(index) {
  const _response = props.responses[index];
  const _question = props.questions[index];
  let _note = note.value[index];
  if (_note === undefined || _note === null) {
    noNoteError.value[index] = true;
    return;
  }
  noNoteError.value[index] = false;
  sendContent(_question, _response, _note);
  hasRated.value[index] = true;
}

watch(() => props.questions, (newQuestions) => {
  if (newQuestions.length === 0) {
    note.value = [];
    hasRated.value = [];
    noNoteError.value = [];
  }
}, { deep: true });

watch(() => props.responses, (newResponses) => {
  const index = props.nb;
  if (newResponses[index] !== undefined && newResponses[index] !== null && !hasRated.value[index]) {
    noNoteError.value[index] = false;
  }
}, { deep: true });

</script>

<style>
ul {
  list-style: none;
}

.card-chat + .card-chat {
    margin-top: 80px;
}

.ia-eval-group{
  opacity: .3;
  will-change: scale;
}

.ia-eval:hover .ia-eval-group{
  opacity: 1;
}
</style>
